<template>
  <div v-show="isActive">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'show-tab',
  props: {
    name: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return  {
      isActive: false
    }
  },
  mounted() {
    this.isActive = this.selected
  }
}
</script>